<template>
  <modal name='comment-modal' 
      :height="'auto'"
      :width="'90%'"
      @closed="reloadCommentModal">
    <div class="container p-5">
      <h4>Nowy komentarz:</h4>
      <br>
      <form class="form-group" @submit.prevent>
        <textarea class="form-control" v-model.trim="comment" placeholder="Treść komentarza"></textarea>
        <div class="row">
           <button @click="addComment()" :disabled="comment == ''" class="btn btn-success m-3">Dodaj komentarz</button>
        </div>
       
      </form>
    </div>
  </modal>
</template>

<script>
import { commentsCollection, tasksCollection, auth } from '@/firebase'

export default {
  props: ['oneTask'],
  data() {
    return {
      comment: ''
    }
  },
  methods: {
    async addComment() {
      // create comment
      await commentsCollection.add({
        createdOn: new Date(),
        content: this.comment,
        taskId: this.oneTask.id,
        userId: auth.currentUser.uid,
        userName: this.$store.state.userProfile.name
      })

      // update comment count on post
      await tasksCollection.doc(this.oneTask.id).update({
        comments: parseInt(this.oneTask.comments) + 1
      })

      // close modal
      this.$modal.hide('comment-modal')
    },
    reloadCommentModal(){
      this.$emit('clear-comment')
    }
  }
}
</script>
